// extracted by mini-css-extract-plugin
export default {"font-serif":"font-serif_Ovhyu","cityView":"cityView_YXNaA","contentContainer":"contentContainer_pGWZi","mainImage":"mainImage_JHD8j"};